import React, { useEffect } from "react";
import {
  User,
  Camera,
  Mail,
  Phone,
  Calendar,
  IdCard,
  QrCode,
  Lock,
  Save,
  Check,
  ArrowLeft,
  Upload,
  ChevronDown,
  Trash2,
} from "lucide-react";
import { getStoredData, removeSpecificData } from "../../utils/localStorage";
import { useNavigate } from "react-router-dom";
import UseMyProfile from "../../hooks/UseMyProfile/UseMyProfile";
import "./MyProfile.css";

const MyProfile = () => {
  const navigate = useNavigate();
  const {
    user,
    form,
    fieldErrors,
    filePreview,
    colorMsgfile,
    fileUploadedSucessfully,
    updatePassword,
    colorMsgPassword,
    passwordLoading,
    updatePersonalData,
    setUpdatePersonalData,
    colorMsgPersonalData,
    setColorMsgPersonalData,
    personalDataLoading,
    fileInputRef,
    handleChange,
    handleCpfChange,
    handleDateChange,
    handlePhoneChange,
    handleFileChange,
    openFilePicker,
    pixOpen,
    setPixOpen,
    pixOptions,
    handlePasswordSubmit,
    handlePersonalDataSubmit,
    validateField,
  } = UseMyProfile();

  useEffect(() => {
    const storedData = getStoredData();
    const editProfile = storedData?.edit_profile;

    if (editProfile) {
      setUpdatePersonalData("Dados pessoais alterados com sucesso!");
      setColorMsgPersonalData("#0bb96bff");

      setTimeout(() => {
        setUpdatePersonalData("");
        removeSpecificData("edit_profile");
      }, 2000);
    }
  }, []);

  return (
    <>
      <div className="my-profile-page">
        <div className="my-profile-container">
          <div className="my-profile-header">
            <button
              className="back-btn"
              type="button"
              onClick={() => navigate(-1)}
            >
              <ArrowLeft size={18} />
              Voltar
            </button>

            <div className="header-title">
              <h1>Meu Perfil</h1>
              <p>Atualize os seus dados pessoais, foto e senha da conta.</p>
            </div>
          </div>

          <div className="my-profile-grid">
            <aside className="my-profile-card avatar-card">
              {fileUploadedSucessfully ? (
                <div
                  style={{
                    backgroundColor: colorMsgfile,
                    color: "#fff",
                    padding: "12px 16px",
                    borderRadius: "8px",
                    border: `1px solid ${colorMsgfile}`,
                    fontSize: "14px",
                    margin: "12px auto 20px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                    fontWeight: 500,
                    boxShadow: "rgba(0, 0, 0, 0.05) 0px 2px 4px",
                    width: "95%",
                  }}
                >
                  {fileUploadedSucessfully}
                </div>
              ) : null}

              <div className="avatar-wrap">
                <div className="avatar">
                  {filePreview || form.img ? (
                    <img
                      src={filePreview || form.img}
                      alt="Foto do perfil"
                      className="avatar-image"
                    />
                  ) : (
                    <User size={42} />
                  )}
                </div>
                <button
                  className="camera-btn"
                  type="button"
                  onClick={openFilePicker}
                >
                  <Camera size={16} />
                </button>
              </div>

              <h2>Foto do perfil</h2>
              <p>Altere a sua foto para personalizar a conta.</p>

              <button
                className="secondary-btn"
                type="button"
                onClick={openFilePicker}
              >
                <Upload size={16} />
                Alterar foto
              </button>

              <input
                type="file"
                accept="image/*"
                ref={fileInputRef}
                onChange={handleFileChange}
                style={{ display: "none" }}
              />
            </aside>

            <main className="my-profile-content">
              <section className="my-profile-card form-card">
                {updatePersonalData ? (
                  <div
                    style={{
                      backgroundColor: colorMsgPersonalData,
                      color: "#fff",
                      padding: "12px 16px",
                      borderRadius: "8px",
                      border: `1px solid ${colorMsgPersonalData}`,
                      fontSize: "14px",
                      margin: "12px auto 20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      fontWeight: 500,
                      boxShadow: "rgba(0, 0, 0, 0.05) 0px 2px 4px",
                      width: "95%",
                    }}
                  >
                    {updatePersonalData}
                  </div>
                ) : null}
                <div className="card-title">
                  <h2>Dados pessoais</h2>
                </div>

                <div className="form-grid">
                  <div className="input-group full">
                    <label>Nome completo</label>
                    <div
                      className={`input-box ${fieldErrors.name ? "error" : ""}`}
                    >
                      <User size={16} />
                      <input
                        type="text"
                        name="name"
                        value={form.name}
                        onChange={(e) => handleChange("name", e.target.value)}
                        onBlur={() => validateField("name")}
                      />
                    </div>
                    {fieldErrors.name ? (
                      <div
                        style={{
                          color: "#f00",
                          fontSize: 14,
                          marginLeft: 10,
                          marginTop: 10,
                        }}
                      >
                        {fieldErrors.name}
                      </div>
                    ) : null}
                  </div>

                  <div className="input-group">
                    <label>Email</label>
                    <div
                      className={`input-box ${fieldErrors.email ? "error" : ""}`}
                    >
                      <Mail size={16} />
                      <input
                        value={form.email}
                        onChange={(e) => handleChange("email", e.target.value)}
                        onBlur={() => validateField("email")}
                      />
                    </div>
                    {fieldErrors.email ? (
                      <div
                        style={{
                          color: "#f00",
                          fontSize: 14,
                          marginLeft: 10,
                          marginTop: 10,
                        }}
                      >
                        {fieldErrors.email}
                      </div>
                    ) : null}
                  </div>

                  <div className="input-group">
                    <label>Data de nascimento</label>
                    <div
                      className={`input-box ${fieldErrors.date_birth ? "error" : ""}`}
                    >
                      <Calendar size={16} />
                      <input
                        placeholder="DD/MM/AAAA"
                        name="date_birth"
                        value={form.date_birth}
                        onChange={(e) => handleDateChange(e.target.value)}
                        onBlur={() => validateField("date_birth")}
                      />
                    </div>
                    {fieldErrors.date_birth ? (
                      <div
                        style={{
                          color: "#f00",
                          fontSize: 14,
                          marginLeft: 10,
                          marginTop: 10,
                        }}
                      >
                        {fieldErrors.date_birth}
                      </div>
                    ) : null}
                  </div>

                  <div className="input-group">
                    <label>Telefone com Whatsapp</label>
                    <div
                      className={`input-box ${fieldErrors.phone ? "error" : ""}`}
                    >
                      <Phone size={16} />
                      <input
                        type="tel"
                        name="phone"
                        value={form.phone}
                        onChange={(e) => handlePhoneChange(e.target.value)}
                        onBlur={() => validateField("phone")}
                      />
                    </div>
                    {fieldErrors.phone ? (
                      <div
                        style={{
                          color: "#f00",
                          fontSize: 14,
                          marginLeft: 10,
                          marginTop: 10,
                        }}
                      >
                        {fieldErrors.phone}
                      </div>
                    ) : null}
                  </div>

                  <div className="input-group">
                    <label>CPF</label>
                    <div
                      className={`input-box ${fieldErrors.cpf ? "error" : ""}`}
                    >
                      <IdCard size={16} />
                      <input
                        type="text"
                        value={form.cpf}
                        onChange={(e) => handleCpfChange(e.target.value)}
                        onBlur={() => validateField("cpf")}
                        maxLength={14}
                        placeholder="000.000.000-00"
                      />
                    </div>

                    {fieldErrors.cpf ? (
                      <div
                        style={{
                          color: "#f00",
                          fontSize: 14,
                          marginLeft: 10,
                          marginTop: 10,
                        }}
                      >
                        {fieldErrors.cpf}
                      </div>
                    ) : null}
                  </div>

                  <div className="input-group">
                    <label>Tipo de chave pix</label>

                    <div
                      className={`pix-select ${
                        fieldErrors.type_pix ? "error" : ""
                      }`}
                    >
                      <button
                        type="button"
                        className="pix-select-trigger"
                        onClick={() => setPixOpen(!pixOpen)}
                      >
                        <div className="pix-select-left">
                          <QrCode size={16} />

                          <span
                            className={
                              form.type_pix
                                ? "pix-selected-value"
                                : "pix-placeholder"
                            }
                          >
                            {form.type_pix || "Selecione o tipo de chave"}
                          </span>
                        </div>

                        <ChevronDown
                          size={18}
                          className={`pix-arrow ${pixOpen ? "open" : ""}`}
                        />
                      </button>

                      {pixOpen && (
                        <div className="pix-dropdown">
                          {pixOptions.map((option) => (
                            <button
                              key={option}
                              type="button"
                              className={`pix-option ${
                                form.type_pix === option ? "active" : ""
                              }`}
                              onClick={() => {
                                handleChange("type_pix", option);
                                validateField("type_pix");
                                setPixOpen(false);
                              }}
                            >
                              <span>{option}</span>

                              {form.type_pix === option && <Check size={16} />}
                            </button>
                          ))}
                        </div>
                      )}
                    </div>

                    {fieldErrors.type_pix ? (
                      <div
                        style={{
                          color: "#f00",
                          fontSize: 14,
                          marginLeft: 10,
                          marginTop: 10,
                        }}
                      >
                        {fieldErrors.type_pix}
                      </div>
                    ) : null}
                  </div>

                  <div className="input-group">
                    <label>Chave PIX</label>
                    <div
                      className={`input-box ${fieldErrors.key_pix ? "error" : ""}`}
                    >
                      <QrCode size={16} />
                      <input
                        type="text"
                        value={form.key_pix}
                        onChange={(e) =>
                          handleChange("key_pix", e.target.value)
                        }
                        onBlur={() => validateField("key_pix")}
                      />
                    </div>

                    {fieldErrors.key_pix ? (
                      <div
                        style={{
                          color: "#f00",
                          fontSize: 14,
                          marginLeft: 10,
                          marginTop: 10,
                        }}
                      >
                        {fieldErrors.key_pix}
                      </div>
                    ) : null}
                  </div>

                  <div className="form-actions full">
                    <button
                      className="save-btn"
                      disabled={personalDataLoading}
                      onClick={handlePersonalDataSubmit}
                    >
                      <Save size={16} />
                      {personalDataLoading ? "Enviando..." : "Salvar perfil"}
                    </button>
                  </div>
                </div>
              </section>

              <section className="my-profile-card password-card">
                {updatePassword ? (
                  <div
                    style={{
                      backgroundColor: colorMsgPassword,
                      color: "#fff",
                      padding: "12px 16px",
                      borderRadius: "8px",
                      border: `1px solid ${colorMsgPassword}`,
                      fontSize: "14px",
                      margin: "12px auto 20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                      fontWeight: 500,
                      boxShadow: "rgba(0, 0, 0, 0.05) 0px 2px 4px",
                      width: "95%",
                    }}
                  >
                    {updatePassword}
                  </div>
                ) : null}

                {user?.cadastro_google || user?.cadastro_facebook ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      textAlign: "center",
                    }}
                  >
                    <div className="social-login-alert">
                      <div className="social-icon">
                        {user.cadastro_google ? (
                          // Google SVG menor (não 500x500!)
                          <svg viewBox="0 0 24 24" width="20" height="20">
                            <path
                              fill="#EA4335"
                              d="M5.266 9.765A7.077 7.077 0 0 1 12 4.909c1.69 0 3.218.6 4.418 1.582L19.91 3C17.782 1.145 15.055 0 12 0 7.33 0 3.357 2.72 1.5 6.662l3.766 3.103z"
                            />
                            <path
                              fill="#34A853"
                              d="M16.04 15.345c-1.104.722-2.454 1.146-4.04 1.146-2.927 0-5.423-1.982-6.307-4.655L1.886 14.93A11.933 11.933 0 0 0 12 24c3.19 0 6.136-1.127 8.364-3.05l-4.324-5.605z"
                            />
                          </svg>
                        ) : (
                          <svg
                            viewBox="0 0 24 24"
                            width="20"
                            height="20"
                            fill="#1877F2"
                          >
                            <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                          </svg>
                        )}
                      </div>

                      <div className="social-text">
                        Login via{" "}
                        <strong>
                          {user.cadastro_google ? "Google" : "Facebook"}
                        </strong>
                        <span> — sem senha local</span>
                      </div>
                    </div>
                  </div>
                ) : (
                  /* CASO CONTRÁRIO: Exibe o formulário padrão de alteração de senha */
                  <>
                    <div className="card-title">
                      <h2>Alterar senha</h2>
                    </div>

                    <div className="form-grid">
                      <div className="input-group full">
                        <label>Senha atual</label>
                        <div
                          className={`input-box ${fieldErrors.current_password ? "error" : ""}`}
                        >
                          <Lock size={16} />
                          <input
                            type="password"
                            value={form.current_password}
                            onChange={(e) =>
                              handleChange("current_password", e.target.value)
                            }
                            onBlur={() => validateField("current_password")}
                          />
                        </div>
                      </div>
                      {fieldErrors.current_password ? (
                        <small style={{ color: "#f00", marginLeft: 5 }}>
                          {fieldErrors.current_password}
                        </small>
                      ) : null}

                      <div className="input-group full">
                        <label>Nova senha</label>
                        <div
                          className={`input-box ${fieldErrors.new_password ? "error" : ""}`}
                        >
                          <Lock size={16} />
                          <input
                            type="password"
                            value={form.new_password}
                            onChange={(e) =>
                              handleChange("new_password", e.target.value)
                            }
                            onBlur={() => validateField("new_password")}
                          />
                        </div>
                      </div>
                      {fieldErrors.new_password ? (
                        <small style={{ color: "#f00", marginLeft: 5 }}>
                          {fieldErrors.new_password}
                        </small>
                      ) : null}

                      <div className="input-group full">
                        <label>Confirmar nova senha</label>
                        <div
                          className={`input-box ${fieldErrors.repeat_password ? "error" : ""}`}
                        >
                          <Lock size={16} />
                          <input
                            type="password"
                            value={form.repeat_password}
                            onChange={(e) =>
                              handleChange("repeat_password", e.target.value)
                            }
                            onBlur={() => validateField("repeat_password")}
                          />
                        </div>
                      </div>
                      {fieldErrors.repeat_password ? (
                        <small style={{ color: "#f00", marginLeft: 5 }}>
                          {fieldErrors.repeat_password}
                        </small>
                      ) : null}

                      <div className="form-actions full">
                        <button
                          className="save-btn"
                          disabled={passwordLoading}
                          onClick={handlePasswordSubmit}
                        >
                          <Save size={16} />
                          {passwordLoading ? "Enviando..." : "Salvar senha"}
                        </button>
                      </div>
                    </div>
                  </>
                )}
              </section>
              <section className="my-profile-card danger-card">
                <div className="danger-header">
                  <div>
                    <h2>Zona de perigo</h2>
                    <p>
                      A exclusão da conta é permanente. Todos os seus dados,
                      viagens, avaliações e histórico serão removidos
                      definitivamente.
                    </p>
                  </div>
                </div>

                <button
                  className="delete-account-btn"
                  onClick={() => {
                    const confirmDelete = window.confirm(
                      "Tem certeza que deseja excluir sua conta? Esta ação é permanente e não poderá ser desfeita.",
                    );

                    if (confirmDelete) {
                      // chamar API para excluir conta
                      // handleDeleteAccount();
                    }
                  }}
                >
                  <Trash2 size={18} />
                  Excluir minha conta
                </button>
              </section>
            </main>
          </div>
        </div>
      </div>
    </>
  );
};

export default MyProfile;
